import { Link } from 'react-router-dom'

export default function SiteFooter() {
  return (
    <footer className="site-footer">
      <Link className="footer-mark" to="/">Road Stack.</Link>
      <p>One stack. Every drive.</p>
      <nav aria-label="Footer navigation">
        <Link to="/demo">Demo</Link>
        <Link to="/integrations">Integrations</Link>
        <Link to="/about">About</Link>
      </nav>
    </footer>
  )
}
